import { STATUS_OPTIONS } from './eventsFiltersConfig';

export const buildChargebacksFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'Venue Name',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
    ],
  },
  {
    id: 'event',
    label: 'Event',
    filters: [
      {
        id: 'event_name',
        label: 'Event Name',
        type: 'search',
        options: (filterOptions.event_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
      {
        id: 'calendar_classification',
        label: 'Event Status',
        type: 'checkbox',
        options: STATUS_OPTIONS,
      },
    ],
  },
  {
    id: 'dispute_details',
    label: 'Dispute Details',
    filters: [
      {
        id: 'state',
        label: 'State',
        type: 'checkbox',
        options: [
          { value: 'open', label: 'Open' },
          { value: 'submitted', label: 'Submitted' },
          { value: 'closed', label: 'Closed' },
        ],
      },
      {
        id: 'reason',
        label: 'Reason',
        type: 'checkbox',
        options: (filterOptions.reason_options || []).map(o => ({
          value: o,
          label: o.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
        })),
      },
    ],
  },
];
